import { render, staticRenderFns } from "./polCollectionOther.vue?vue&type=template&id=4fe18c72&scoped=true"
import script from "./polCollectionOther.vue?vue&type=script&lang=js"
export * from "./polCollectionOther.vue?vue&type=script&lang=js"
import style0 from "./polCollectionOther.vue?vue&type=style&index=0&id=4fe18c72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe18c72",
  null
  
)

export default component.exports